import React, { PureComponent } from 'react';
import { TouchableOpacity, div, StyleSheet } from 'react-native';
import Button from '@dbk/ui-buttons';
import debounce from 'lodash/debounce';
import { createContainer } from '@dbk-legacy/muster/react'
import Text, { H1, H2, H5, Large } from '@dbk/ui-text'
import {
  NavigationList,
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemFooter,
} from '@dbk/ui-list'
import Modal from '@dbk/ui-modal';
import { ROUTES, ACCOUNT_TYPE, PALETTE } from '../../../constants';
import { Transactions, NotificationWarning, NotificationConfirmation, StatusError } from '@dbk/ui-icons'
import { ErrorIcon, WarningIcon, SuccessIcon } from '../../../components/common/icons';
// import '../../../../src/assets/styles/payment-psd2.scss';
import Spinner from '@dbk/ui-spinner';
import message from '@dbk/ui-icons/src/message';
import styles from '../payment-confirmation.styles';

class AccountAccessSummaryrequest extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      distinctAccount: [],
      permissionString: '',
      dedicatedAccountsList: []
    }
  }

  dataFilter(consentDetails) {
    const distinctAccounts = [];
    const combinedData = [];
    let tempIban;
    let string = "";
    const recordContainArray = [];
    const tempIbanRecordArray = [];

    if (consentDetails.access) {
      for (let [key, value] of Object.entries(consentDetails.access)) {
        // find(el => el.iban === data.iban);
        consentDetails.access[key].map((row) => {
          const newObj = {
            ...row,
            "accountType": key
          }
          combinedData.push(newObj);
        })
      }
    }

    combinedData.forEach(eachRecord => {
      string = "";
      tempIban = eachRecord.iban;
      const checkExist = tempIbanRecordArray.includes(tempIban);
      if (!checkExist) {
        tempIbanRecordArray.push(tempIban);
        const objArray = combinedData.filter((filterRecord, index) => {
          if (filterRecord.iban === tempIban) {
            string += combinedData.length === index + 1  ? this.makeFirstCharUpperCase(filterRecord.accountType) : this.makeFirstCharUpperCase(filterRecord.accountType) + ', ';
            filterRecord.accountType = string;
            return filterRecord;
          }
        });
        recordContainArray.push(objArray);
      }
    })

    recordContainArray.map((data) => {
      data.map((item, index) => {
        if (item.iban) {
          if (index === data.length - 1) {
           // remove last comma from string
            const textWithoutComma = item.accountType.replace(/,\s*$/, "");
            item.accountType= textWithoutComma;
            distinctAccounts.push(item);
          }
        }
      })
    })
    this.setState({ dedicatedAccountsList: distinctAccounts })
  }

  componentDidUpdate(){
    if(document.querySelector('.modal__header-container')){
      document.querySelector('.modal__header-container').focus();
    }
    if(document.querySelector('div h2')){
      document.querySelector('div h2').focus();
    }
  }
  makeFirstCharUpperCase(stringCaseString) {
    const { auth : { langCode }} = this.props;

    let firstCharUpperCaseStr = stringCaseString[0].toUpperCase() + stringCaseString.slice(1);
    
    if(langCode === 'en') {
      if(firstCharUpperCaseStr.toLowerCase() === 'ownername') {
        return firstCharUpperCaseStr.slice(0,5) + " " + firstCharUpperCaseStr.slice(5);
      } else {
        return firstCharUpperCaseStr;
      }
    } else {  // German translation for Account type Values
      if(firstCharUpperCaseStr.toLowerCase() === ACCOUNT_TYPE.OWNERNAME) {
        return 'Name des Eigentümers';
      }
      if(firstCharUpperCaseStr.toLowerCase() === ACCOUNT_TYPE.TRANSACTION) {
        return 'Handeln';
      }
      if(firstCharUpperCaseStr.toLowerCase() === ACCOUNT_TYPE.BALANCES) {
        return 'Salden';
      }
      if(firstCharUpperCaseStr.toLowerCase() === ACCOUNT_TYPE.ACCOUNTS) {
        return 'Konten';
      }
    }

  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ais.isAccountOtpVerified !== nextProps.ais.isAccountOtpVerified) {
      //this.props.ais.saveConsentDetails();
      this.callConsentUpdate();
    }
    if (this.props.ais.consentDetails !== nextProps.ais.consentDetails) {
      if (nextProps.ais.consentType !== "bankDriven") {
        this.dataFilter(nextProps.ais.consentDetails);
      }
      this.getPermissionString(nextProps.ais.consentDetails);
    }
  }

  onDone() {
    const { ais: { resetStatus }, changePage } = this.props;
    resetStatus();
    changePage(ROUTES.PORTFOLIO.DASHBOARD, true);
  }

  onConfirm() {
    const { ais: { saveAccountConfirmation } } = this.props;
    saveAccountConfirmation("confirm");
  }

  onReject() {
    const { ais: { saveAccountConfirmation } } = this.props;

    saveAccountConfirmation("reject");
    this.callConsentUpdate();
  }

  getPermissionString(details) {
    let string = '';
    let count = 0;
    let objLength = 0;

    for (const key in details.access) {
      if (details.access.hasOwnProperty(key)) {
        if (details.access[key].length > 0) { objLength++; }
      }
    }
    for (const [key] of Object.entries(details.access)) {
      if (details.access[key].length > 0) {
        ++count;
        if(objLength === 1){
          string += this.makeFirstCharUpperCase(key);
        }
        if(objLength >= 2){
          string += this.makeFirstCharUpperCase(key);
          if(objLength !== count){
            string += objLength - 1 === count ? ' and ' : ', ';
          }
        }
      }
    }
    // string = string.substr(0, string.length - 1);
    this.setState({ permissionString: string })
  }

  callConsentUpdate() {
    const {
      settings: { currentEnvironment: { remoteUrl } },
      auth: { userId, authHeader, langCode },
      app:{config, user},
      i18n: { messages },
  } = this.props;
    this.props.ais.saveConsentDetails(this.props.ais.consentAccessData, remoteUrl,userId, authHeader, langCode, config, user);
  }

  renderAccountDetails(row) {
    return (
      <NavigationListItem disabled tabIndex={-1}>
        {this.props.ais.consentType === "bankDriven" ? <div className="row overflow-break-word">
          <div tabIndex={0} className="column large-3 medium-3 small-3">
            <span>{row.portfolio || "-"}</span>
          </div>
          <div tabIndex={0} className="column large-3 medium-3 small-3">
            <span secondary>{row.accountName} </span>
          </div>
          <div tabIndex={0} className="column large-3 medium-3 small-3">
            <span>{row.accountCurrency}</span>
          </div>
          <div tabIndex={0} className="column large-3 medium-3 small-3">
            <span>{row.iban}</span>
          </div>
        </div> :
          <div className="row overflow-break-word">
            <div tabIndex={0} className="column large-2 medium-2 small-2">
              <span>{row.portfolio || "-"}</span>
            </div>
            <div tabIndex={0} className="column large-3 medium-3 small-3">
              <span secondary>{row.accountName} </span>
            </div>
            <div tabIndex={0} className="column large-2 medium-2 small-2">
              <span>{row.accountCurrency}</span>
            </div>
            <div tabIndex={0} className="column large-3 medium-2 small-2">
              <span>{row.iban}</span>
            </div>
            <div tabIndex={0} className="column large-2 medium-2 small-2">
              <span>{row.accountType}</span>
            </div>
          </div>
        }
      </NavigationListItem>
    )
  }

  render() {

    const { auth: { langCode }, i18n: { messages }, ais: { consentDetails, showSpinner, errorMsg, consentAccountDetails, consentType } } = this.props;

    if (showSpinner) {
      return <div className="spinnerPosition"><Spinner size="large" /></div>
    }

    if (errorMsg) {
      return <div>
        <Modal
          isActive={true}
          hideCloseButton={true}
          header={<Text size="big">Error</Text>}
          className={"model-window-login"}
          content={
            <div>
              <div tabIndex={0} className="modalNotification">
                <ErrorIcon width={30} color='#999' height={30} />
                <Text size={'large'} className="sucessLabel">{messages['app.common.serviceError']}</Text>
              </div>
              <div className="modalMsg">
                <Text tabIndex={0} className="margin20">{errorMsg}</Text>
              </div>
              <div className="btnDone">
                <Button size='large' onPress={() => this.onDone()}>
                  {messages['app.payment.psd2.doneBtn']}
                </Button>
              </div>
            </div>
          }
        />
      </div>
    }

    if (this.props.ais.isAccountOtpVerified && this.props.ais.aisSuccess) {
      return (
        <div className="payment-status-container">
          <div className="payment-status-content">
            <div className="payment-status-message">
              <div>
                <SuccessIcon color={PALETTE.successColor} width={48} height={48} />
              </div>
              <h2
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payments.confirmation.success']}
              >
                {messages['app.payments.confirmation.success']}
              </h2>
            </div>
            <div>
              <Large
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payment.psd2.consent.successMsg']}
              >
                {messages['app.payment.psd2.consent.successMsg']}
              </Large>
            </div>
          </div>

          <div className="payment-status-footer">
            <div style={StyleSheet.flatten(styles.paymentStatusBtnTerminate)}>
              <div>
                <Button fullWidth size={'large'} onPress={() => this.onDone()}>
                  {messages['app.payment.psd2.doneBtn']}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    if (this.props.ais.isRejected && !this.props.ais.aisSuccess) {
      return (
        <div className="payment-status-container">
          <div className="payment-status-content">
            <div className="payment-status-message">
              <div>
                <StatusError color={PALETTE.errorColor} width={48} height={48} />
              </div>
              <h2
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payments.confirmation.success']}
              >
                {messages['app.payments.confirmation.success']}
              </h2>
            </div>
            <div>
              <Large
                role="alert"
                tabIndex={0}
                aria-label={messages['app.psd2.payment.rejectMsgbyUser']}
              >
                {messages['app.psd2.payment.rejectMsgbyUser']}
              </Large>
            </div>
          </div>

          <div className="payment-status-footer">
            <div style={StyleSheet.flatten(styles.paymentStatusBtnTerminate)}>
              <div>
                <Button fullWidth size={'large'} onPress={() => this.onDone()}>
                  {messages['app.payment.psd2.doneBtn']}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div >
        <div>
          <H1 tabIndex={0}>{messages['app.payment.psd2.ais']}</H1>
        </div>
        <div>
          <div className="psd2-permission-summary"><span><H5 tabIndex={0}>{messages['app.payment.psd2.permissionSummary']}</H5></span></div>
          {/* <div style={{  }}> */}
          <div className="permission-summary">
            <div className="margin10"><span><H5 tabIndex={0}>{consentDetails.tppName} </H5></span></div>

            <div className="row large-12">
              <div className="column large-4 medium-4 small-4 padding5px">
                <Text tabIndex={0} secondary>{messages['app.payment.psd2.multipleAccess']} </Text>
                <span tabIndex={0}>{consentDetails.expirationDate}</span>
              </div>
              <div className="column large-4 medium-4 small-4 padding5px">
                <Text tabIndex={0} secondary>{messages['app.payment.psd2.frequency']} </Text>
                <span tabIndex={0}>{consentDetails.frequencyPerDay + " " + messages['app.payment.psd2.timersPerDay'] }</span>
              </div>
              {consentType === "bankDriven" ? <div className="column large-4 medium-5 small-5 padding5px">
                <Text tabIndex={0} secondary>{messages['app.payment.psd2.permissionType']}: </Text>
                <span tabIndex={0}>{this.state.permissionString} </span>
              </div> : ""}
            </div>
          </div>
          {/* </div> */}
          <span>&nbsp;</span>
          <span>&nbsp;</span>
          <div >
            <div className="row large-12"><span ><H5 tabIndex={0}>{messages['app.payment.psd2.eligibleAccounts']} </H5></span></div>

            {consentType === "bankDriven" && <div className="row padding20px">
              <div tabIndex={0} className="column large-3 medium-3 small-2"><Text secondary>{messages['app.common.pageTitle.portfolio']} </Text></div>
              <div tabIndex={0} className="column large-3 medium-3 small-3"><Text secondary >{messages['app.payment.psd2.cashAccount']}</Text></div>
              <div tabIndex={0} className="column large-3 medium-3 small-2"><Text secondary >{messages['app.common.portfolio.fx.currency']} </Text></div>
              <div tabIndex={0} className="column large-3 medium-3 small-3"><Text secondary >{messages['app.payment.psd2.ibanNo']} </Text></div>
            </div>}
            {consentType !== "bankDriven" && <div className="row padding20px">
              <div tabIndex={0} className="column large-2 medium-2 small-2"><Text secondary>{messages['app.common.pageTitle.portfolio']} </Text></div>
              <div tabIndex={0} className="column large-3 medium-3 small-3"><Text secondary >{messages['app.payment.psd2.cashAccount']}</Text></div>
              <div tabIndex={0} className="column large-2 medium-2 small-2"><Text secondary >{messages['app.common.portfolio.fx.currency']} </Text></div>
              <div tabIndex={0} className="column large-3 medium-3 small-3"><Text secondary >{messages['app.payment.psd2.ibanNo']} </Text></div>
              <div tabIndex={0} className="column large-2 medium-2 small-2"><Text secondary >{messages['app.payment.psd2.permissionType']}</Text></div>
            </div>}
            <span>&nbsp;</span>
            <div>

              <NavigationList hasArrow={false}>
                {consentType === "bankDriven" ? consentAccountDetails.map((row, i) => this.renderAccountDetails(row)) :
                  this.state.dedicatedAccountsList.map((row, i) => this.renderAccountDetails(row))}
              </NavigationList>

            </div>
            <div className="row btn-container">
              <div className="mr-20"><Button size='large' tertiary={true} onPress={() => this.onReject()}>
                {messages['app.payments.summary.reject']}
              </Button></div>
              <div><Button size='large' onPress={() => this.onConfirm()}>{messages['app.payments.summary.confirm']}</Button></div>
            </div>
          </div>
        </div>
      </div >


    )
  }
}
export default createContainer({
  $queries: {
    app: {
      config: {
          apiverion: true
      },
      user: {
          selectedPortfolio: true
      }
  },
    i18n: {
      messages: true,
    },
    auth: {
      addBeneficiaryDisabled: true,
      langCode: true
    },
    changePage: { $call: 'ui.history.push' },
    ais: {
      isAccountConfirmation: true,
      isConfirmed: true,
      isRejected: true,
      // showReject: true,
      aisSuccess: true,
      disctinctRecords: true,
      setIsConfirmed: { $set: 'isConfirmed' },
      setIsRejected: { $set: 'isRejected' },
      consentDetails: true,
      isAccountOtpVerified: true,
      saveConsentDetails: { $call: 'consentUpdate' },
      saveAccountConfirmation: { $call: 'accountConfirmation' },
      resetStatus: { $call: 'resetStatus' },
      setDistinctRecords: { $set: 'disctinctRecords' },
      showSpinner: true,
      errorMsg: true,
      consentAccessData: true,
      consentAccountDetails: true,
      consentType: true
    },
    settings: {
      currentEnvironment: {
          remoteUrl: true,
      },
  },
  auth: {
      userId: true,
      authHeader: true,
      langCode: true
  },
  },
})(AccountAccessSummaryrequest)
